import { FETCH_CONTENT_IMPRESSION_STATS, loadContentImpressionStats } from '../Actions/ContentImpression'
import gql from 'graphql-tag'
import { from, EMPTY } from 'rxjs'
import { filter, mergeMap, map, catchError } from 'rxjs/operators'
import client from '../ApolloClient'

const contentImpressionStatsQuery = gql`
  query GetImpressionStats($accountId: ID!, $startDate: DateTime!, $endDate: DateTime!, $entityIds: [ID!], $platform: String, $appType: String, $groupIds: [ID!], $appProfileIds: [ID!]) {
    impressionStats(accountId: $accountId, startDate: $startDate, endDate: $endDate, entityIds: $entityIds, platform: $platform, appType: $appType, groupIds: $groupIds, appProfileIds: $appProfileIds) {
      entityId
      title
      entityType
      totalImpressions
      uniqueImpressions
      avgDwellTime
      totalDwellTime
      maxDwellTime
      latestImpression
    }
  }
`

/**
 * contentImpressionStatsEpic
 * @desc Epic for fetching content-specific impression stats
 * @param {Observable} action$ stream of actions
 * @return {Observable} stream of actions
 */
export const contentImpressionStatsEpic = (action$) =>
  action$.pipe(
    filter((action) => action.type === FETCH_CONTENT_IMPRESSION_STATS),
    mergeMap((action) => {
      const { accountId, startDate, endDate, entityIds, platform, appType, groupIds, appProfileIds } = action.query
      return from(
        client.query({
          query: contentImpressionStatsQuery,
          variables: { accountId, startDate, endDate, entityIds, platform, appType, groupIds, appProfileIds }
        })
      ).pipe(
        map((response) => loadContentImpressionStats(response.data.impressionStats)),
        catchError((error) => {
          console.error('Error fetching content impression stats:', error)
          return EMPTY
        })
      )
    })
  )
